import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { UserX, CheckCircle, Download, Mail, MessageSquare, Phone, User as UserIcon } from 'lucide-react';

export const ProspectsTab = ({ prospects, handleSendProspectFollowups, handleExport }) => {
  return (
    <Card className="border-0 shadow-lg border-amber-200">
      <CardHeader>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <CardTitle className="text-xl flex items-center gap-2">
              <UserX className="w-5 h-5 text-amber-600" />Prospectos — Registrados sin Compra
            </CardTitle>
            <CardDescription>
              {prospects.length} usuario(s) se registraron pero no completaron su compra. Contacta para cerrar la venta.
            </CardDescription>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button className="bg-[#C81D25] hover:bg-[#A6141B] text-white"
              onClick={handleSendProspectFollowups} data-testid="send-prospect-followups-btn">
              <Mail className="w-4 h-4 mr-2" />Enviar Email a Todos
            </Button>
            <Button variant="outline" className="border-amber-300 text-amber-700" onClick={() => handleExport('prospects')} data-testid="export-prospects-btn">
              <Download className="w-4 h-4 mr-2" />Exportar CSV
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {prospects.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <CheckCircle className="w-12 h-12 mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">Todos los registrados han comprado</p>
            <p className="text-sm">No hay prospectos pendientes</p>
          </div>
        ) : (
          <div className="space-y-3">
            {prospects.map((p) => (
              <div key={p.id} className="flex items-center justify-between p-4 bg-amber-50 rounded-xl border border-amber-100 hover:border-amber-300 transition-colors">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-amber-200 rounded-full flex items-center justify-center">
                      <UserIcon className="w-5 h-5 text-amber-700" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">{p.name}</p>
                      <p className="text-sm text-gray-500">{p.email}</p>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-right hidden md:block">
                    <p className="text-sm text-gray-500">{p.phone || 'Sin teléfono'}</p>
                    <p className="text-xs text-gray-400">Registrado: {p.created_at ? new Date(p.created_at).toLocaleDateString('es-MX') : '-'}</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {p.phone && (
                      <a href={`https://wa.me/52${p.phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-emerald-500 text-white text-sm font-medium hover:bg-emerald-600 transition-colors" title="WhatsApp">
                        <MessageSquare className="w-4 h-4" />
                        <span className="hidden sm:inline">WhatsApp</span>
                      </a>
                    )}
                    <a href={`mailto:${p.email}?subject=Completa tu membresía SOS FindMed&body=Hola ${p.name}, notamos que te registraste en SOS FindMed pero no completaste tu compra. ¿Podemos ayudarte?`}
                      className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-blue-500 text-white text-sm font-medium hover:bg-blue-600 transition-colors" title="Email">
                      <Mail className="w-4 h-4" />
                      <span className="hidden sm:inline">Email</span>
                    </a>
                    {p.phone && (
                      <a href={`tel:${p.phone}`}
                        className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-gray-500 text-white text-sm font-medium hover:bg-gray-600 transition-colors" title="Llamar">
                        <Phone className="w-4 h-4" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
